export default __webpack_public_path__ + "49f4ea366978b73e8177221c9942d728.png";